import ChairDef from "assets/img/ecommerce/ChairDef.png";
import Delete from "./components/Delete";
import Details from "./components/Details";
import DropeZone from "./components/DropZone";
import Information from "./components/Information";
import Socials from "./components/Socials";
import React, {useEffect, useState} from "react";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {AES, enc} from "crypto-js";
import axios from "axios";
import Banner from "./components/Banner";
import FunctionDefinition from "./components/FunctionDefinition";
import FaqDataSection from "./components/FaqDataSection";
import ProductPairingModesFilter from "./components/ProductPairingModesFilter";
import ExecutedSchedulesPerProductGraph from "../../devices/components/ExecutedSchedulesPerProductGraph";
import Alerts from "../../error";
import UserWithDeviceCount from "../../devices/components/UsersWithDeviceCount";
import FirmwareAnalyticsGraph from "../../devices/components/FIrmwareDeviceAnalytics";
import CategoriesDistributionGraph from "../../devices/components/CategoriesDistributionGraph";
import ExecutedSchedulesMonthlyTrend from "../../devices/components/ExecutedSchedulesMonthlyTrend";
import ProductRatingTrendGraph from "../../devices/components/ProductRatingTrendGraph";
import FirmwareUpload from "./components/FirmwareUpload";

const SettingsProduct = () => {
    const secretKey = "cromptonssecretkey";
    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/";
    const params = useParams();
    let [productId, setProductId] = useState("");
    let {Token, logOut, Username} = useUserAuth();
    const navigate = useNavigate();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    let [productImage, setProductImage] = useState("");
    const [productName, setProductName] = useState("eg: Smart Fan");
    const [productCategory, setProductCategory] = useState("");
    const [mfg, setMfg] = useState(0);
    const [def, setDef] = useState("1");
    const [productSubCategory, setProductSubCategory] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            //console.log(error.message);
        }
    }

    const productInformationTab = (productId) => {
        var url = CROMPTON_URL + "product/V2/getProductInfoByPid/" + productId

        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then(res => {
            //console.log(res.data)
            setProductImage(res.data.productIcon)
            productImage = res.data.productIcon
            setProductName(res.data.productName)
            setProductCategory(res.data.productCategory)
            setProductSubCategory(res.data.getProductSubCategory)
            setMfg(sessionStorage.getItem("mfg"))
            setDef(sessionStorage.getItem("def"))
            sessionStorage.setItem("productInfoData", JSON.stringify(res.data))
            setIsLoading(false)

        }).catch((error) => {
            //document.getElementById("errorControlId").hidden = false
            //setmessage(error)
            //console.log(error)
            setIsLoading(false)
            if (error.response.data.status.toString() === "401" || error.response.data.status.toString() === "403") {
                handleLogOut();
            }
        })
    }

    useEffect(() => {
        //console.log("ID: ", params)
        productId = params.id
        setProductId(params.id)
        productInformationTab(params.id)

    }, []);


    return (

        !isLoading &&
        <div>
            <div className="mt-3 h-full w-full rounded-[20px]">
                <Banner
                    image={productImage}
                    profile={productImage === "" ? "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_appliances.png" : productImage}
                    productId={productId}
                    category={productCategory}
                    subCategory={productSubCategory}
                    name={productName}
                    createdTime={sessionStorage.getItem("createdTime")}
                    lastModified={sessionStorage.getItem("lastModified")}
                    mfg={mfg}
                />

            </div>
            <div className="mt-4 grid h-full w-full grid-cols-1 xl:mt-3 ">

                <div className="mt-3 col-span-2 grid h-full grid-cols-1 gap-5 xl:grid-cols-1 2xl:grid-cols-1">
                    {/*<div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">
                        <FunctionDefinition/>
                    </div>
                    <div className="col-span-1 h-full w-full rounded-xl 2xl:col-span-1">
                        <FirmwareUpload/>
                    </div>*/}
                    <FunctionDefinition/>
                    <FirmwareUpload/>
                </div>

                {/* left side*/}
                <div className="col-span-2 mt-10 flex h-full w-full flex-col gap-5 md:grid-cols-1">
                    {/* Chair*/}
                    {/*<FunctionDefinition/>*/}
                    <ProductPairingModesFilter/>
                    <FaqDataSection productId = {productId}/>
                    {/* <Information name={productName}/>*/}
                </div>

                {/*  right side
                <div className="col-span-2 flex h-full w-full flex-col gap-5">
                     <DropeZone/>
                    <FunctionDefinition/>
                    <Socials/>
                </div>*/}

                {/* <div className="col-span-2 flex h-full w-full flex-col gap-5 xl:col-span-1">
                    <ProductPairingModesFilter/>
                    <FunctionDefinition/>
                    <Socials/>
                </div>*/}
                {/* full width */}
                <div className="col-span-2 flex h-full w-full flex-col gap-5">
                    <Delete
                        image={productImage}
                        productId={productId}
                        category={productCategory}
                        subCategory={productSubCategory}
                        name={productName}
                        mfg={mfg}
                        def = {def}
                    />
                </div>
            </div>
        </div>
    );
};

export default SettingsProduct;
